import { AuthService } from '@auth0/auth0-angular';
import { UserService } from './../../services/user/user.service';
import { Component } from '@angular/core';

@Component({
  selector: 'app-header',
  standalone: false,

  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {

  userName: any;
  isMenuCollapsed = true;

  constructor(private readonly userService: UserService,
    private readonly auth: AuthService
  ) { }

  ngOnInit(): void {
    this.userService.getUser().subscribe(user => {
      this.userName = user.name;
    });
  }

  /**
 * calling the below method to logout
 */
  logout() {
    this.auth.logout();
    localStorage.clear();
    sessionStorage.clear();
  }
}
